<template>
  <aside class="sidebar" :class="{ 'collapsed': isSidebarClosed }">
    <a
      @click="goDashboard()"
      :to="{ name: 'Root' }"
      class="logo justify-content-center justify-content-lg-start"
    >
      <Logo :size="windowWidth < 1024 && isSidebarClosed ? 'small' : 'large'" />
    </a>
    <Account
      v-if="agencyInfo"
      :account.sync="agencyInfo"
      :shops.sync="shops"
    />

    <section class="sidenav">
      <article class="pages d-none d-lg-unset mt-6">
        <router-link :to="{ name: 'AgencyDashboard' }" class="nav-link">
          <i class="icon icon-shop"></i>
          <span class="text-item">{{$t("sidebar.dashboard")}}</span>
        </router-link>
        <!-- <router-link :to="{ name: 'NEWS' }" class="nav-link">
          <i class="icon icon-news"></i>
          <span class="text-item">{{ $t("agency.news")}}</span>
        </router-link> -->
        <router-link :to="{ name: 'AgencyFaqs' }" class="nav-link">
          <i class="icon icon-faq"></i>
          <span class="text-item">FAQs</span>
        </router-link>
      </article>

      <article class="acc-nav mt-auto">
        <div class="nav-link subtitle">
          <span>{{$t("upperCase.account")}}</span>
        </div>

        <router-link :to="{ name: 'AgencySettings' }" class="nav-link">
          <i class="icon icon-acc-settings"></i>

          <span class="text-item">{{$t("accountSettings.headerTitle")}}</span>
        </router-link>
      </article>
    </section>

    <div class="toggler" v-if="windowWidth < 1024" @click="toggleDrawer(null)">
      <i class="icon icon-arrow-right" v-if="isSidebarClosed"></i>
      <i class="icon icon-arrow-left" v-else></i>
    </div>
  </aside>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Logo from "@/core/components/Logo.vue";
import Account from "./Account";
export default {
  name: "AgencySidebar",
  components: {
    Logo,
    Account
  },
  data() {
    return {
      open: {
        product: false,
        collection: false
      },
      height: 1024,
      windowWidth: 1024
    };
  },
  computed: {
    ...mapState({
      drawer: state => state.drawer.status,
      isSidebarClosed: state => state.drawer.opening
    }),
    ...mapState("agency", {
      shops: state => state.shopList,
      agencyLogged: state => state.logged,
      agencyInfo: state => state.info
    }),
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.windowResizeHandler();
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.windowResizeHandler();
      this.resizeHandler();
      let handler = this.windowResizeHandler;
      window.addEventListener("resize", handler);
    });
  },
  mounted() {
    this.windowResizeHandler();
  },
  beforeDestroy() {
    let handler = this.windowResizeHandler;
    this.$nextTick(() => {
      window.removeEventListener("resize", handler);
    });
  },
  methods: {
    ...mapMutations({
      toggleDrawer: "drawer/DRAWER_TOGGLE_DRAWER",
      updateSize: "drawer/DRAWER_UPDATE_WINDOW_SIZE"
    }),
    resizeHandler() {},

    windowResizeHandler() {
      // console.warn("TGGLE");
      this.height = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.updateSize({
        width: this.windowWidth,
        height: this.height
      });

      if (this.windowWidth < 1024) {
        // If it's Opening => Close it
        if (!this.isSidebarClosed) {
          this.toggleDrawer();
        }
      } else {
        // If it's closed => Open it
        if (this.isSidebarClosed) {
          this.toggleDrawer();
        }
      }
    },
    goDashboard() {
      let url = window.location.href;
      let arr = url.split("/");
      let host = arr[0] + "//" + arr[2];
      window.location.href = host + "/admin/dashboard"
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/core/themes/partials/_utils.scss";

// @import "@/core/themes/base.scss";

.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  min-width: 280px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  @include trans-all;
  z-index: 1000;

  .logo {
    // width: calc(100%);
    padding: 16px 24px;
    display: flex;
  }
  a{
    cursor: pointer;
  }
  section.account-container {
    // width: 100%;
    min-height: 87px;
    position: relative;

    .account {
      // height: 100%;
      margin-left: 8px;
      border-radius: 10px;
      width: 100%;
      padding: 20px 0 20px 24px;
      box-shadow: 0px 7px 20px rgba(0, 24, 46, 0.15);
    }
  }

  .sidenav {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    // width: calc(100% + 2px);

    > .pages {
      margin-bottom: 16px;
    }

    .help-center {
      margin-top: auto;

      .gp_dropdown {
        &_list {
          top: unset;
          bottom: 100%;
          right: -16px;
        }
      }
    }

    .acc-nav {
      margin-top: 34px;
      margin-bottom: 32px;
    }

    .nav-link {
      padding: 5px 0 5px 24px;
      padding-top: 13px;
      padding-bottom: 13px;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      position: relative;
      text-decoration: none;
      @include trans-all;
      @include no-select;

      .text-item {
        height: 20px;
      }

      &.view-more {
        padding-left: 0;
      }

      &,
      &:active {
        color: inherit;
      }

      &.subtitle {
        color: $shade6;
        font-size: 12px;
        line-height: 18px;
        padding-top: 0;
        padding-bottom: 0;
      }

      svg,
      i.icon {
        margin-right: 20px;
        font-size: 20px;
        line-height: 20px;
        color: $shade6;
        @include trans-all;
      }

      &.dashboard {
        margin: 32px 0;
      }

      // &:not(:first-child) {
      //   padding-top: calc(16px + 5px);
      // }
      &.disabled {
        color: $grey3;
        i.icon {
          color: $grey3;
        }
        &.open .arrow i.icon {
          color: $grey3;
        }
      }

      &:not(.subtitle):not(.disabled):hover,
      &.rl-eactive,
      &.rl-active {
        svg,
        i.icon {
          color: $cPrimary;
        }

        cursor: pointer;
        color: #0060e5;
      }

      // &.rl-eactive {
      //   color: $cPrimary;
      //   // border-right: 2px solid $cPrimary;
      //   // width: calc(100% - 24px);
      // }

      &.open {
        .arrow {
          display: flex;
          align-items: center;
          margin-left: auto;

          i.icon {
            font-size: 12px;
            line-height: 12px;
            color: $black1;
            font-weight: 500;
          }
        }
      }

      // i.icon.icon-menu {
      //   transform: rotate(90deg);
      // }

      .badge {
        margin-left: 15px;
      }
    }

    .sub-nav {
      background-color: $grey5;
      padding: 12px 0 12px 20px;
      margin-top: 8px;
    }
  }

  &.collapsed {
    width: 80px;
    min-width: 80px;

    .sidenav {
      // padding-top: 20px;

      .nav-link {
        padding-left: 0;

        @include flex-center;

        &:not(.subtitle) > span {
          display: none;
        }

        &.subtitle {
          text-align: center;
          padding-left: 0;
          margin-top: 24px;
          padding: 0 8px;

          span {
            width: 100%;
          }
        }

        &:not(:first-child) {
          padding-top: calc(8px + 5px);
        }

        i.icon {
          margin-right: 0px;
          font-size: 26px;
        }

        &.dashboard {
          margin: 0;
        }
      }

      .pages {
        margin-bottom: 0;
      }

      .sub-nav {
        padding-left: 0px;
      }

      .help-center {
        .view-more {
          margin-top: 0;
        }

        .gp_dropdown {
          /deep/ {
            .no-padding {
              padding: 0 0 0 24px;
            }

            .gp_dropdown_list {
              width: 200px;
              left: 10px;

              span {
                display: inline;
              }
            }
          }
        }
      }

      .acc-nav {
        margin: 0 0 16px 0;
      }
    }

    & + .gp-wrapper {
      margin-left: 80px;
    }

    /deep/ .account-container {
      min-height: 36px;
      margin-bottom: 16px;

      .account {
        padding: 9px;
      }

      .name,
      .plan > span {
        display: none;
      }

      .upgrade > i.icon {
        margin: 0 4px !important;
      }
    }

    .toggler {
      width: 32px;
      padding-left: 20px;
    }
  }

  .toggler {
    @include flex-center;
    position: absolute;
    top: 12px;
    right: -7px;
    padding: 4px;
    height: 24px;
    width: 60px;
    padding-left: 28px;
    border-radius: 0px 5px 5px 0px;
    font-size: 14px;
    background: #fff;
    cursor: pointer;
  }
}

.badge {
  @include flex-center;
  padding: 1px 5px;
  font-size: 10px;
  line-height: 15px;
  border-radius: 10px;
  width: 17px !important;
  height: 17px !important;

  &-danger {
    background-color: $cRed;
    color: #fff;
  }
}

@media only screen and (max-width: 1023px) {
  .sidebar {
    /deep/ .account-container {
      margin-bottom: 16px;
    }

    .sidenav .nav-link.subtitle {
      margin-top: 24px;
    }

    &:not(.collapsed) {
      .logo {
        justify-content: flex-start !important;
      }
    }
  }
}

</style>
